import React, { useState } from 'react';
// import Papa from 'papaparse';
import CSVReader from 'react-csv-reader';

const CsvUploader = () => {
    const [jsonData, setJsonData] = useState(null);

    const handleFileUpload = (data) => {
        // Convert the CSV data to JSON
        const json = data.map(row => {
            return Object.fromEntries(row.map((cell, index) => [data[0][index], cell]));
        }).slice(1);
        setJsonData(json);
    };
    console.log("data:", jsonData);
    return (
        <div>
            <h2>Upload CSV and Convert to JSON</h2>
            <CSVReader
                cssClass="csv-reader-input"
                label="Select CSV"
                onFileLoaded={handleFileUpload}
                onError={console.error}
                inputId="csvUpload"
                inputStyle={{ color: 'red' }}
            />
            {jsonData && (
                <div>
                    <h3>JSON Output</h3>
                    <pre>{JSON.stringify(jsonData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default CsvUploader;

// import React, { useState } from 'react';
// import CSVReader from 'react-csv-reader';

// const CsvUploader = () => {
//     const [jsonData, setJsonData] = useState(null);
//     const [jsonUrl, setJsonUrl] = useState(null);

//     const handleFileUpload = (data) => {
//         // Convert the CSV data to JSON
//         const json = data.map(row => {
//             return Object.fromEntries(row.map((cell, index) => [data[0][index], cell]));
//         }).slice(1);

//         setJsonData(json);

//         // Create a blob from the JSON data and generate a download URL
//         const blob = new Blob([JSON.stringify(json, null, 2)], { type: 'application/json' });
//         const url = URL.createObjectURL(blob);
//         setJsonUrl(url);
//     };
//     console.log("data:", jsonData);
//     return (
//         <div>
//             <h2>Upload CSV and Convert to JSON</h2>
//             <CSVReader
//                 cssClass="csv-reader-input"
//                 label="Select CSV"
//                 onFileLoaded={handleFileUpload}
//                 onError={console.error}
//                 inputId="csvUpload"
//                 inputStyle={{ color: 'red' }}
//             />
//             {jsonData && (
//                 <div>
//                     <h3>JSON Output</h3>
//                     {/* <pre>{JSON.stringify(jsonData, null, 2)}</pre> */}
//                     <a href={jsonUrl} download="data.json">
//                         Download JSON File
//                     </a>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CsvUploader;


// import { Button } from '@material-ui/core';
// import React, { useState, useRef } from 'react';
// import Papa from 'papaparse'; // or use CSVReader if you prefer

// const CsvUploader = () => {
//     const fileInputRef = useRef(null);
//     const [jsonData, setJsonData] = useState(null);
//     const [assetList, setAssetList] = useState([]);

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         if (file) {
//             Papa.parse(file, {
//                 complete: (result) => {
//                     const json = result.data.map((row, rowIndex) => {
//                         return rowIndex === 0
//                             ? null
//                             : Object.fromEntries(row.map((cell, index) => [result.data[0][index], cell]));
//                     }).filter(row => row !== null);
//                     setJsonData(json);
//                     // Extract "Asset" values and set to assetList
//                     const assets = json.map(item => item["Asset       "].trim());
//                     console.log("fff",assets)
//                     setAssetList(assets);

//                 },
//                 header: false
//             });
//         }
//     };

//     const importCSVHandler = () => {
//         if (fileInputRef.current) {
//             fileInputRef.current.click(); // Trigger the file input click
//         }
//     }

//     return (
//         <div>
//             <h2>Upload CSV and Convert to JSON</h2>
//             <input
//                 type="file"
//                 accept=".csv"
//                 ref={fileInputRef}
//                 style={{ display: 'none' }}
//                 onChange={handleFileUpload}
//             />
//             <Button
//                 type="button"
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 onClick={importCSVHandler}
//             >
//                 Import CSV
//             </Button>

//             {jsonData && (
//                 <div>
//                     <h3>JSON Output</h3>
//                     <pre>{JSON.stringify(jsonData, null, 2)}</pre>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CsvUploader;
